import { BottomSheet } from "components/BottomSheet";
import { SignatureInput } from "components/SignatureInput";

type Props = {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  onSubmit: (signature: string | null) => void;
  isPending?: boolean;
  existingSignatureInBase64?: string | null; // base64 PNG data URL
};

export const OperatorSignatureSheet = ({
  isOpen,
  title,
  onClose,
  onSubmit,
  isPending,
  existingSignatureInBase64,
}: Props) => (
  <BottomSheet isOpen={isOpen} onClose={onClose} title={title}>
    <SignatureInput
      sendImageToParent={onSubmit}
      cancel={onClose}
      isLoading={isPending}
      existingSignatureInBase64={existingSignatureInBase64}
    />
  </BottomSheet>
);
